export enum GridTypeEnum {
  ONE_COLUMN = 'ONE_COLUMN',
  TWO_COLUMNS_50_50 = 'TWO_COLUMNS_50_50',
  TWO_COLUMNS_30_70 = 'TWO_COLUMNS_30_70',
  TWO_COLUMNS_70_30 = 'TWO_COLUMNS_70_30',
  THREE_COLUMNS_30_30_30 = 'THREE_COLUMNS_30_30_30',
  THREE_COLUMNS_25_50_25 = 'THREE_COLUMNS_25_50_25',
}
